
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import moment from 'moment';

@Component({
	components: {},
})
export default class Portal extends Vue {
    public year = moment().year().valueOf();
}
